import { ReactElement, useState, FC } from "react";
import { Tab, Tabs, TabList, Box } from "@chakra-ui/react";
import { BasicPageLayout } from "../components/templates/BasicPageLayout";
import { ThemeColorSelect } from "../components/molecules/ThemeColorSelect";
import { VisualizerSelect } from "../components/molecules/VisualizerSelect";
import { useModifiedTranslation } from "../hooks/useModifiedTranslation";

export function ColorLayout(): ReactElement {
  const t = useModifiedTranslation();
  const [selectMode, setSelectMode] = useState("color");

  type SelectTabProps = {
    label: string;
    onClick: () => void;
  };

  const SelectTab: FC<SelectTabProps> = ({ label, onClick }) => (
    <Tab
      fontWeight="bold"
      fontSize={14}
      color="common_text.gray"
      margin={1.5}
      borderRadius="full"
      _active={{ backgroundColor: "white" }}
      sx={{
        "@media (hover: hover)": {
          "&:hover": { backgroundColor: "white" },
        },
      }}
      _selected={{
        color: "common_text.dark",
        bgColor: "white",
        margin: 1.5,
        borderRadius: "full",
      }}
      onClick={onClick}
    >
      {label}
    </Tab>
  );

  return (
    <BasicPageLayout
      title={t("Setting.itemTitleColorLayout")}
      titleProps={{ fontSize: "2xl" }}
      showBackButton
      h="full"
    >
      <Box>
        <Tabs
          variant="unstyled"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <TabList
            bgColor="login.login_button_bg"
            borderRadius="full"
            justifyContent="center"
          >
            <SelectTab
              label={t("SelectColorLayout.color")}
              onClick={() => setSelectMode("color")}
            />
            <SelectTab
              label={t("SelectColorLayout.layout")}
              onClick={() => setSelectMode("layout")}
            />
          </TabList>
        </Tabs>
      </Box>
      <Box overflowY="auto" mt={4} paddingRight={1}>
        {selectMode === "color" && <ThemeColorSelect />}
        {selectMode === "layout" && <VisualizerSelect />}
      </Box>
    </BasicPageLayout>
  );
}
